import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue !");
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 bg-[#0F172A] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-10" />
        <div className="relative p-12 flex flex-col justify-between w-full">
          <Link to="/" className="font-display text-2xl tracking-tight">Xpert Recruit AI</Link>
          <div className="space-y-4">
            <div className="text-xs tracking-[0.3em] uppercase text-slate-400">Citation recruteur</div>
            <p className="font-display text-3xl leading-tight">"Enfin une IA qui me donne ce que j'ai besoin d'envoyer, pas juste un score."</p>
            <div className="text-slate-400 text-sm">— Camille L., Talent Acquisition Lead</div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 lg:p-12">
        <div className="w-full max-w-sm">
          <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-2">Connexion</div>
          <h1 className="font-display text-3xl tracking-tight mb-8">Bon retour parmi nous.</h1>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider text-slate-500">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider text-slate-500">Mot de passe</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11" data-testid="login-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0F172A] hover:bg-[#1E293B] btn-pill" data-testid="login-submit-btn">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-500">
            Pas encore de compte ? <Link to="/signup" className="text-[#2563EB] font-medium link-underline" data-testid="login-signup-link">Créer un compte</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
